import * as React from 'react';
export const IcGateway2 = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.12 12.88A3 3 0 0019 12V9a1 1 0 00-2 0v3H7V9a1 1 0 00-2 0v3a3 3 0 00-3 3v2a3 3 0 003 3h14a3 3 0 003-3v-2a3 3 0 00-.88-2.12zM9 17H6a1 1 0 110-2h3a1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zm4 0a1 1 0 110-2 1 1 0 010 2zM8.36 6.89a7.93 7.93 0 017.28 0 1 1 0 10.91-1.78 9.94 9.94 0 00-9.1 0 1 1 0 00.91 1.78zm1.23 1.64a1.003 1.003 0 00.82 1.83 3.691 3.691 0 013.18 0c.129.059.268.09.41.09a1 1 0 00.91-.59 1.001 1.001 0 00-.5-1.33 5.79 5.79 0 00-4.82 0z'
      fill='currentColor'
    />
  </svg>
);
